/*****************************************************************************************************************************************************
 * Availability monitoring *
 ****************************************************************************************************************************************************/
define('commons/monitoring/availability-monitoring',['jquery', 'commons/monitoring/base-monitoring'], function($, BaseMonitoring) {
    
    var AvailabilityMonitoring = function(seriesArray) {
        // Call parent init method
        BaseMonitoring.apply(this, Array.prototype.slice.call(arguments, 1));
        var data = {};
        for (var i = 0; i < seriesArray.length; i++) {
            var array = new Array(200).map(function() {
                return 0;
            });
            data[seriesArray[i]] = array;
        }
        this.values = {
            data: data,
            time: 0,
            step: 10000
        };
    };
    

    // Inherit from AvailabilityMonitoring
    for ( var element in BaseMonitoring.prototype) {
        AvailabilityMonitoring.prototype[element] = BaseMonitoring.prototype[element];
    }

    AvailabilityMonitoring.prototype.processResponse = function(result) {
        var lastPower = result.lastPower;
        var step = result.step;
        var data = [];
        var labels = ["Power"];

        var tmpData = [];
        var transformers = [];
        if (this.wildcardKey) {
            // use scope in data to build labels
            for ( var key in result.data) {
                var d = result.data[key];
                tmpData.push(d);
                transformers.push(this.transformers[key] ? this.transformers[key] : this.identity);
                labels.push(key);
            }
        } else {
            // Keys and labels of a given mapping key have the same length
            for (var i = 0; i < this.mapping.keys.length; i++) {
                var key = this.mapping.keys[i];
                var d = result.data[key];
                if (d) {
                    tmpData.push(d);
                    transformers.push(this.transformers[key] ? this.transformers[key] : this.identity);
                    labels.push(this.mapping.labels[i]);
                }
            }
        }
        if (tmpData.length > 0) {
            // Data from a given mapping key have the same length
            for (var i = 0; i < tmpData[0].length; i++) {
                var dataRow = [];
                for (var j = 0; j < tmpData.length; j++) {
                    dataRow[j] = (isNaN(tmpData[j][i]) ? 0 : transformers[j](tmpData[j][i]));
                }
                // last time is in seconds and Date object in milliseconds
                var power = lastPower - step * (tmpData[0].length - 1 - i);
                data.push($.merge([power], dataRow));
            }
        }

        var drawOptions = $.extend({
            stepPlot: true
        }, this.drawOptions);

        return {
            data: data,
            labels: labels,
            drawOptions: drawOptions
        };
    };
    
    AvailabilityMonitoring.prototype.loadData = function(params) {
        this.chart.addClass("loading");
        var result = this.processResponse(this.values);
        if (result && result.data.length > 0) {
            if (this.dygraph === null) {
                this.chart.css("text-align", "left").css("height", this.chart.data('height')).empty();
                this.dygraph = new Dygraph(this.chart.get(0), result.data, $.extend({
                    labels: result.labels,
                    fillGraph: true,
                    connectSeparatedPoints: true,
                    labelsDiv: this.label.get(0),
                    hideOverlayOnMouseOut: false,
                    legend: "always",
                    axisLabelFontSize: 12
                }, result.drawOptions));
            } else {
                this.dygraph.updateOptions({
                    labels: result.labels,
                    file: result.data
                });
            }
        } else {
            this.chart.css("text-align", "center").css("height", "auto").html("No data to display");
            this.dygraph = null;
        }
        this.chart.removeClass("loading");
    };

    AvailabilityMonitoring.prototype.redraw = function() {
        if (this.dygraph != null) {
            this.dygraph.destroy();
            this.dygraph = null;
            this.loadData();
        }
    };

    return AvailabilityMonitoring;
});

